export interface HeroChip {
  icon: string;
  value: string;
  label: string;
}

export const heroChips: HeroChip[] = [
  { icon: 'ri-focus-2-line', value: '128 颗', label: '全年收录大瓜' },
  { icon: 'ri-eye-line', value: '3.7 亿人次', label: '围观总量' },
  { icon: 'ri-fire-line', value: '56 次', label: '霸榜热搜' },
];

export interface StatItem {
  value: string;
  unit: string;
  label: string;
  note: string;
}

export const statItems: StatItem[] = [
  { value: '128', unit: '颗', label: '全年收录大瓜', note: '娱乐到社会全覆盖' },
  { value: '96', unit: '位', label: '年度瓜主登场', note: '有名字、有故事、有反转' },
  { value: '18', unit: '小时', label: '单瓜平均霸榜时长', note: '最久的一颗挂了两天半' },
  { value: '67', unit: '%', label: '被吃出「后续」', note: '你以为结束，其实才开头' },
];

export interface KingItem {
  rank: number;
  title: string;
  cat: string;
  summary: string;
  month: string;
  heat: string;
}

export const kingItems: KingItem[] = [
  {
    rank: 1,
    title: '顶流塌房连环瓜：一夜掉粉 800 万',
    cat: '娱乐',
    summary: '从一张机场照开始，两天内被扒出多条时间线，顺藤牵出同门三人，反转里套反转，教科书级连环瓜。',
    month: '06 月',
    heat: '92.4',
  },
  {
    rank: 2,
    title: '科技大厂数据风波，一夜反转两次',
    cat: '商业',
    summary: '用户信息疑遭批量流出，官方前后两版回应互相打架，程序员连夜写段子，饭圈与码农罕见同框。',
    month: '03 月',
    heat: '88.1',
  },
  {
    rank: 3,
    title: '奥运赛场外的意外剧情',
    cat: '社会',
    summary: '金牌之外，颁奖台下一记击掌引爆全网解读，当事人一句「顺手」把热度顶到了最高点。',
    month: '08 月',
    heat: '85.7',
  },
  {
    rank: 4,
    title: '离婚官宣与复合悬念',
    cat: '娱乐',
    summary: '官宣文案只差一个字就被扒出隐藏彩蛋，评论区从「尊重祝福」一路吵到「我再嗑一口」。',
    month: '11 月',
    heat: '83.2',
  },
  {
    rank: 5,
    title: '爆火小吃店排队背后的账本',
    cat: '商业',
    summary: '黄牛代排、限购加价，一张小票被晒出十几倍溢价，烟火气里藏着的生意经被摊开来看。',
    month: '04 月',
    heat: '79.6',
  },
  {
    rank: 6,
    title: '求职平台「假面」事件',
    cat: '社会',
    summary: '岗位描述与实发待遇对不上，多名应届生联名晒图，招聘信息是否失真成了舆论焦点。',
    month: '10 月',
    heat: '77.9',
  },
  {
    rank: 7,
    title: '主播带货翻车与「自掏腰包」',
    cat: '网络',
    summary: '选品出问题后当场表态补差价，真金白银还是又一次话术，评论区正反两派各执一词。',
    month: '02 月',
    heat: '75.3',
  },
  {
    rank: 8,
    title: '公园相亲角新规引发的争论',
    cat: '社会',
    summary: '「先看本人再看条件」的横幅被贴出来，老一辈与年轻人对婚姻的想象又撞了个满怀。',
    month: '05 月',
    heat: '73.0',
  },
];

export interface GuaItem {
  title: string;
  summary: string;
  month: string;
  tag: string;
}

export interface Category {
  id: string;
  name: string;
  tagline: string;
  items: GuaItem[];
}

export const categories: Category[] = [
  {
    id: 'yule',
    name: '娱乐',
    tagline: '戏里戏外，都有名场面',
    items: [
      { title: '影后宣布息影，圈内集体发小作文', summary: '一场告别引发多年搭档回忆杀，评论区排起「有缘再见」长队。', month: '05 月', tag: '官宣' },
      { title: '爆款剧男主，戏外比戏里还精彩', summary: '剧刚播到一半，主演的旧采访被考古，人设与发言被逐句对照。', month: '07 月', tag: '考古' },
      { title: '跨年晚会抢镜名场面', summary: '镜头、站位与表情管理全部拉满，谁接住了谁是最大赢家早有预判。', month: '01 月', tag: '名场面' },
      { title: '恋综官宣，CP 粉提前过年', summary: '节目之外真走到一起，全平台话题量三小时破亿，糖度超标。', month: '02 月', tag: '甜瓜' },
    ],
  },
  {
    id: 'shehui',
    name: '社会现场',
    tagline: '身边事，最下饭',
    items: [
      { title: '深夜排队的「网红面馆」卫生疑云', summary: '后厨画面流出，排队三小时值不值得，食客与店家各说各话。', month: '04 月', tag: '争议' },
      { title: '奥运赛场外的击掌剧情', summary: '领奖台下的一次互动，被拆出十种解读，当事人一句回应定调。', month: '08 月', tag: '暖瓜' },
      { title: '公园相亲角新规', summary: '「先看本人再看条件」，老一辈与年轻人对婚姻的想象撞了个满怀。', month: '05 月', tag: '热议' },
      { title: '求职平台的「假面」', summary: '岗位与实发待遇对不上，应届生晒图联名，招聘真假成了焦点。', month: '10 月', tag: '真相' },
    ],
  },
  {
    id: 'shangye',
    name: '商业品牌',
    tagline: '生意场上的瓜，又大又圆',
    items: [
      { title: '老字号联名翻车现场', summary: '经典口味配新包装，老粉不买账、新粉看不懂，跨界出了反效果。', month: '09 月', tag: '翻车' },
      { title: '科技大厂数据泄露两反转', summary: '官方两版回应前后矛盾，最终以一份长文说明收尾，信任重建未完。', month: '03 月', tag: '连环' },
      { title: '「自掏腰包」式带货售后', summary: '翻车后现场补差价，是真金白银还是新话术，全在细节里。', month: '02 月', tag: '对线' },
      { title: '双十一「最快发货」纪录', summary: '尾款人刚睡醒快递已到家，速度是拼出来了，预售规则仍被吐槽。', month: '11 月', tag: '纪录' },
    ],
  },
  {
    id: 'wangluo',
    name: '网络红人',
    tagline: '屏幕内外，人设都有人盯',
    items: [
      { title: '百万粉博主停更 21 天后回归', summary: '一支长视频交代来龙去脉，弹幕从「催更」刷到「心疼」再刷到「学到了」。', month: '12 月', tag: '回归' },
      { title: '「泼天流量」的带货翻车', summary: '爆红三天直播首秀，选品与话术被逐帧复盘，流量来得快去得也快。', month: '06 月', tag: '翻车' },
      { title: '短视频博主人设翻新风波', summary: '从「拼爹」到「逆袭」的叙事切换，被网友考古出多处时间冲突。', month: '07 月', tag: '考古' },
      { title: '公益直播的「小作文」', summary: '一场直播后晒出明细单，透明与否，网友用显微镜一条条对。', month: '10 月', tag: '透明' },
    ],
  },
];

export interface MonthItem {
  m: string;
  title: string;
  type: string;
}

export const monthItems: MonthItem[] = [
  { m: '01', title: '跨年晚会名场面刷屏', type: '娱乐' },
  { m: '02', title: '顶流恋综官宣，CP 粉过年', type: '甜瓜' },
  { m: '03', title: '科技大厂数据风波，双反转', type: '商业' },
  { m: '04', title: '网红面馆卫生疑云开锤', type: '社会' },
  { m: '05', title: '影后息影，回忆杀上线', type: '娱乐' },
  { m: '06', title: '顶流塌房，年度瓜王诞生', type: '年度瓜王' },
  { m: '07', title: '带货翻车与考古齐飞', type: '网络' },
  { m: '08', title: '奥运赛场外的意外剧情', type: '社会' },
  { m: '09', title: '老字号联名翻车', type: '商业' },
  { m: '10', title: '求职季骗局曝光', type: '社会' },
  { m: '11', title: '官宣与复合悬念开场', type: '娱乐' },
  { m: '12', title: '年度盘点，咱们自己凑了个热闹', type: '吃瓜王' },
];

export interface TalkItem {
  user: string;
  letter: string;
  time: string;
  topic: string;
  replies: string;
  up: string;
  state: string;
}

export const talkItems: TalkItem[] = [
  { user: '不吃鱼', letter: '鱼', time: '今天 14:02', topic: '求助：有没有人存了年度盘点第六颗瓜的名场面完整版，想复盘。', replies: '1.2k', up: '8.6k', state: '热聊中' },
  { user: '熬夜冠军', letter: '冠', time: '今天 11:47', topic: '理性讨论：瓜反转了，之前急着开骂的人，要不要道个歉？', replies: '3.4k', up: '2.1k', state: '理性讨论' },
  { user: '圈外人小李', letter: '李', time: '昨天 22:15', topic: '刚入坑，谁来按时间线给我捋一遍今年的「年度瓜王」？', replies: '2.8k', up: '5.4k', state: '补课中' },
  { user: '瓜田管理员', letter: '管', time: '昨天 20:03', topic: '本楼汇总当事各方回应的原文与链接，欢迎随时补充。', replies: '5.9k', up: '12k', state: '置顶' },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: '榜单是怎么评出来的？',
    a: '每颗瓜按「发酵速度、全网讨论量、影响面、反转次数」四个维度综合打分，再由编辑部三轮交叉复核，最后加权出榜。年度瓜王即综合分最高者。',
  },
  {
    q: '瓜的来源靠谱吗？',
    a: '只收录有公开信源或可核实时间线的事件，并标注首发与后续回应；传闻类内容会明确标「传闻中」，不会把小道消息当实锤端上来。',
  },
  {
    q: '瓜反转了，你们会改吗？',
    a: '会。守则第一条就是及时修正：一旦出现新的官方信息或证据，我们会在盘点内更新标注，并在热聊楼里说明前后的变化。',
  },
  {
    q: '可以投稿或补充线索吗？',
    a: '欢迎。到「热聊现场」发帖即可，请附上可查证的时间与来源。涉及个人隐私的内容，我们会谨慎处理后再考虑收录。',
  },
  {
    q: '为什么叫「瓜」？',
    a: '网络俗语里把值得围观的热点称作「瓜」，大家聚在一起围观、讨论就叫「吃瓜」。名字取自这种轻松围观、理性讨论的氛围。',
  },
  {
    q: '吃瓜有什么边界？',
    a: '我们不倡导网络暴力、人肉与造谣。请在公开信息范围内讨论，少一点「喊打喊杀」，多一点「有来有回」，热闹才能吃得长久。',
  },
];

export interface PrincipleItem {
  icon: string;
  t: string;
  d: string;
}

export const principles: PrincipleItem[] = [
  { icon: 'ri-eye-line', t: '信源标注', d: '每颗瓜都标清「实锤 / 多方印证 / 传闻中」，公开可查，不吃来路不明的瓜。' },
  { icon: 'ri-search-line', t: '多方核实', d: '榜单前先交叉核对时间线与当事方说法，宁可慢一点，不急着下结论。' },
  { icon: 'ri-user-3-line', t: '尊重当事人', d: '只讨论公共事件本身，不评头论足长相与私生活，不鼓励人肉与网暴。' },
  { icon: 'ri-refresh-line', t: '及时修正', d: '新信息一出现立刻更新标注，错了就大方说一句「已更新」，底线在瓜前。' },
];